import React, { FC, memo } from 'react';

import { useNotificationContext } from 'application/providers/NotificationProvider';
import CommunicationUtils from 'application/utils/CommunicationUtils';
import InteractiveErrorToaster from 'application/components/InteractiveErrorToaster';

import { Country } from 'domain/api/graphql/generated';

import { TEXTS } from './texts';

const CompanyAlreadyExistsToaster: FC = () => {
  const notification = useNotificationContext();

  const onConnectWithManager = () => {
    const whatsAppLink = CommunicationUtils.getWhatsAppLink(Country.Ru);

    window.open(whatsAppLink, '_blank');
  };

  return (
    <InteractiveErrorToaster
      onSubmit={onConnectWithManager}
      onClose={notification.hideNotification}
      title={TEXTS.INPUT_SBBID_ERROR_COMPANY_ALREADY_EXISTS}
      submitButtonTitle={TEXTS.INPUT_SBBID_ERROR_COMPANY_ALREADY_EXISTS_MANAGER}
      closeButtonTitle={TEXTS.INPUT_SBBID_ERROR_COMPANY_ALREADY_EXISTS_CLOSE}
      elementId="company_already_exists"
    />
  );
};

export default memo(CompanyAlreadyExistsToaster);
